'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  STOREFRONT: null,
  PURCHASED: null
});